import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import UserStore from "./stores/UserStore";
import ProductStore from "./stores/ProductsStore";
import CartStore from "./stores/CartStore";
import AdminStore from "./stores/AdminStore";
import DownloadsStore from "./stores/DownloadsStore";
import "react-dates/initialize";
import "./css/index.css";
import "react-dates/lib/css/_datepicker.css";
import App from "./components/App";
import registerServiceWorker from "./registerServiceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import { StripeProvider } from "react-stripe-elements";

ReactDOM.render(
	<StripeProvider apiKey="pk_live_gBn7gU83QNY5WEGueUl89V0B">
		<Provider
			UserStore={UserStore}
			ProductStore={ProductStore}
			CartStore={CartStore}
			AdminStore={AdminStore}
			DownloadsStore={DownloadsStore}
		>
			<Router>
				<App />
			</Router>
		</Provider>
	</StripeProvider>,
	document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js